import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

export default function store(settings=null) {
    return new Vuex.Store({
        state: {
            debugMode: settings ? (settings.debugMode === true) : false,
            modalVisible: false,
            loadingProcesses: 0,
            images: settings ? settings.images : [],
            selectedImage: null,
        },
        getters,
        mutations,
        actions
    })
}

